/**
 * Gets the Conversations configuration object and returns various needed
 * properties.
 */
export default function getConversationsEmbedConfig() {
    // @ts-ignore
    if (typeof window.DIConversationsConfig === "undefined") {
        throw new Error("Conversations not loaded on the page.");
    }

    return {
        // @ts-ignore
        endpoint: window.DIConversationsConfig.endpoints.conversationsNode,
        // @ts-ignore
        locationId: window.DIConversationsConfig.raw.id,
        // @ts-ignore
        pusherKey: window.DIConversationsConfig.raw.pusherKey,
        // @ts-ignore
        avatar: window.DIConversationsConfig.raw.avatar,
    };
}
